import { 
  setValuesMultipleSelectDeliveryAssociateStatus, 
  setValuesMultipleSelectDriverType, 
  setValuesMultipleSelectOrderFrom, 
  setValuesMultipleSelectTripStatus, 
  setValuesMultipleSelectVehicleOwnership 
} from "../store/reducer/globalMultipleSelect.reducer"

export const resetAllGlobalValueMultipleSelect = (dispatch) => {
  dispatch(setValuesMultipleSelectDeliveryAssociateStatus);
  dispatch(setValuesMultipleSelectDriverType);
  dispatch(setValuesMultipleSelectOrderFrom);
  dispatch(setValuesMultipleSelectTripStatus);
  dispatch(setValuesMultipleSelectVehicleOwnership);
}